import { Injectable } from '@angular/core';
import {Observable, of, timer} from 'rxjs';

import { PreloadingStrategy, Route } from '@angular/router';
import {AppService} from '../services/app.service';
import {flatMap} from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {

  constructor(private appService: AppService, private authService: MsalService) {}

  preload(route: Route, loadRoute: () => Observable<any>): Observable<any> {
    // Preloading bypasses canActivate, so guarded routes must not fetch chunks before login.
    const isGuarded = !!(route.canActivate && route.canActivate.length);
    const isAuthenticated = this.authService.instance.getAllAccounts().length > 0;
    if (isGuarded && !isAuthenticated) {
      return of(null);
    }

    if (route.data && route.data['preload']) {
      const delay: number = route.data['delay'];
      return this.appService.waitForStable$(timer(delay)).pipe(
        flatMap(_ => {
          return loadRoute();
        }));
    } else {
      return of(null);
    }
  }
}
